import { __assign as e } from "../../../../tslib@2.5.0/node_modules/tslib/tslib.es6.js";
import { pascalCaseTransform as s, pascalCaseTransformMerge as o, pascalCase as f } from "../../../../pascal-case@3.1.2/node_modules/pascal-case/dist.es2015/index.js";
function m(a, r) {
  return r === 0 ? a.toLowerCase() : s(a, r);
}
function c(a, r) {
  return r === 0 ? a.toLowerCase() : o(a);
}
function C(a, r) {
  return r === void 0 && (r = {}), f(a, e({ transform: m }, r));
}
export {
  C as camelCase,
  m as camelCaseTransform,
  c as camelCaseTransformMerge
};
